import { Injectable } from '@angular/core';

import { ApiService, AppContext, BillingService } from './../../shared';

@Injectable()
export class InvoicesService {
  invoices: Array<any> = new Array();
  loaderOn = true;

  constructor(private api: ApiService, private app: AppContext, private billing: BillingService) {
    this.getInvoices();
  }

  getInvoices() {
    this.billing.getInvoices().then(result => {
      this.invoices = result;
      this.loaderOn = false;
    }).catch(err => {
      this.api.handleError(err);
      this.loaderOn = false;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/invoices/invoices.service.ts